export default class Point {
    constructor (lat, lng) {
        this.lat = lat
        this.lng = lng
    }
}
